import type { WifiValidationErrors } from './types';

/**
 * Pure Wi-Fi credential validation shared by the web onboarding flow.
 * (The mobile flow keeps its own inline copy in useDeviceConfigFlow.ts.)
 */
export function validateWifiCredentials(
  wifiname: string,
  wifipassword: string,
): WifiValidationErrors {
  const errors: WifiValidationErrors = {};
  if (!wifiname.trim()) {
    errors.wifiname = 'Please enter your Wi-Fi network name.';
  }
  if (!wifipassword.trim()) {
    errors.password = 'Please enter your Wi-Fi password.';
  }
  return errors;
}
